<template>
  <div class="container">
    <el-form :inline="true">
      <el-form-item label="名称">
        <el-input v-model="name" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="getList(1)">搜索</el-button>
        <el-button type="success" @click="openAdd">新增</el-button>
      </el-form-item>
    </el-form>
    <auto-table
      :DataList="DataList"
      :option="Option"
      :total="Total"
      @changePage="getList"
    >
      <template #avatar="{ row }">
        <img :src="row.avatar" class="avatar" />
      </template>
       <template #platform="{ row }">
        <div>
          {{getPlatforms(row.main_platform)}}
        </div>
        <div>
          {{getEntrys(row.main_entry)}}
        </div>
      </template>
      <template #handler="{ row }">
        <div>
          <el-button type="primary" size="small" @click="openUpdate(row)"
            >接待能力设置</el-button
          >
        </div>
      </template>
    </auto-table>

    <editCustomer ref="edit" @success="getList(1)"></editCustomer>
    <addCustomerService ref="add" @success="getList(1)"></addCustomerService>
  </div>
</template>

<script>
import { platformList,entryList } from "./components/dict";
import addCustomerService from "./components/customer/addCustomerService.vue";
import editCustomer from './components/customer/editCustomer.vue';

export default {
  components: {
    addCustomerService,
    editCustomer
  },
  data() {
    return {
      DataList: [],
      Option: [
        { name: "头像", value: "avatar", type: "custom" },
        { name: "名称", value: "name" },
        { name: "接待模块", value: "platform", type: "custom" },
        { name: "添加时间", value: "create_time" },
        { name: "操作", value: "handler", type: "custom" },
      ],
      Total: 0,
      status: 1,
      form: { nick: "", avatar: "" },
      updateShow: false,
      userInfo: {},
      name: ''
    };
  },

  mounted() {
    this.getList(1);
  },

  methods: {
     getPlatforms(val){
        let res = val.split(',').map(t=>{
          return this.getNameByValue(platformList,t)
        })
        return res.join(',')
    },
     getEntrys(val){
        let res = val.split(',').map(t=>{
          return this.getNameByValue(entryList,t)
        })
        return res.join(',')
    },
    openUpdate(row) {
      this.$refs.edit.open(row)
    },
    openAdd() {
      this.$refs.add.open();
    },
    openEdit(row) {
      this.$refs.add.open(row);
    },
    //获取列表
    getList(v) {
      let page = v || 1;
      this.$axios({
        url: "/chat/customerService/queryManagerListPage",
        params: {
          currentPage: page,
          pageSize: 10,
          name: this.name || null
        },
      }).then((res) => {
        this.DataList = res.data.data.rows;
        this.Total = res.data.data.total;
      });
    },
  },
};
</script>

<style lang="less" scoped>
.avatar {
  width: 50px;
  height: 50px;
}
</style>